import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { ConfigService } from '../config.service';
import { AuthService } from './auth.service';

export enum LoginSessionState {
  None,
  NotLoggedIn,
  LoggedIn,
  Expiring,
}

@Injectable({
  providedIn: 'root',
})
export class SessionTimerServiceService {
  public loginSessionStateChanged = new BehaviorSubject<LoginSessionState>(LoginSessionState.None);
  private idleTimeout // 20 minutes in milliseconds
  public timer: number;

  constructor(private authService: AuthService, private configService: ConfigService) {
    let config = this.configService.getConfiguration() ?? null;
    this.idleTimeout = (config?.expirationtime ?? 20) * 60 * 1000;
    this.authService.loggedIn.subscribe(isLoggedIn => {
      if (isLoggedIn) {
        this.start();
      }
    });

  }

  public start(): void {
    this.timer = window.setInterval(() => {
      this.authService.setpermissions();
    }, this.idleTimeout);

  }
}
